import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, Input, Toast } from 'antd-mobile';
import http from '../../utils/request';
import './index.scss';
import wx from '../../common/img/wx.png';
import xc from '../../common/img/xc.png';
import { localSToken } from '../../utils/storage';

export default function Home() {
    const navigate = useNavigate();
    const [currentTime, setCurrentTime] = useState('');
    const [visible, setVisible] = useState(false); // Default is false
    const [inputValue, setInputValue] = useState('');
    const [isAuthorized, setIsAuthorized] = useState(false);
    const inputRef = useRef<any>(null);

    useEffect(() => {
        const intervalId = setInterval(() => {
            const date = new Date();
            const time = date.toLocaleTimeString();
            setCurrentTime(time);
        }, 1000);
        return () => clearInterval(intervalId);
    }, []);

    const handleConfirm = async () => {
        Toast.show({
            icon: 'loading',
            content: '校验中',
        });

        try {
            const res = await http.post<{ sk: string }, string>("encryption/CompareDataWithFile", { data: { sk: inputValue } });
            if (res.code === 0) {
                setIsAuthorized(true);
                setVisible(false);
                Toast.show({
                    content: '校验成功',
                });
                localSToken().set(res.data)
                inputRef.current?.blur();
                navigate('/album');
            } else {
                Toast.show({
                    content: '校验失败，请确认信息',
                });
            }
        } catch (error) {
            Toast.show({
                content: '请求错误，请稍后重试',
            });
        }
    };

    return (
        <div className='HomeBox'>
            <Dialog
                visible={visible}
                title="邀请编码"
                content={
                    <Input
                        placeholder="请您输入邀请码"
                        ref={inputRef}
                        value={inputValue}
                        onChange={val => setInputValue(val)}
                        autoFocus
                        onBlur={() => window.scrollTo(0, 0)}
                    />
                }
                closeOnAction={false}
                actions={[{
                    key: 'confirm',
                    text: '确定',
                    onClick: handleConfirm,
                }]}
            />
            <div className='bBox'>

                <img src="/images/gyl.jpg" alt="" />
            </div>
            <div className='timeBox'>
                <span className='time'>{currentTime}</span>
            </div>
            <div className='funcBox'>
                <div onClick={() => setVisible(true)}>
                    <img src={xc} alt="" />
                    <div className='wz'>相册</div>
                </div>
                <div onClick={() => navigate('/phone')}>
                    <img src={wx} alt="" />
                    <div className='wz'>微信</div>
                </div>
            </div>
        </div>
    );
}
